import type { SVGProps } from "react";

export default function BookmarkMessageIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.0005 10.7269V7.39801C14.0005 4.53895 14.0005 3.10941 13.1218 2.22121C12.2432 1.33301 10.8289 1.33301 8.00049 1.33301C5.17206 1.33301 3.75785 1.33301 2.87917 2.22121C2.00049 3.10941 2.00049 4.53895 2.00049 7.39801V10.7269C2.00049 12.7913 2.00049 13.8235 2.4899 14.2745C2.7233 14.4897 3.01792 14.6248 3.33177 14.6607C3.98984 14.736 4.75831 14.0563 6.29526 12.6969C6.97462 12.096 7.31436 11.7955 7.70736 11.7164C7.90089 11.6774 8.10009 11.6774 8.29362 11.7164C8.68662 11.7955 9.02636 12.096 9.70569 12.6969C11.2427 14.0563 12.0112 14.736 12.6692 14.6607C12.9831 14.6248 13.2777 14.4897 13.5111 14.2745C14.0005 13.8235 14.0005 12.7913 14.0005 10.7269Z"
        stroke="#F4F4F4"
        strokeWidth="1.16667"
      />
    </svg>
  );
}
